<template>
  <div class="container">
    <my-header :isSenior.sync="isSenior" />
    <div class="box">
      <div class="search">
        <el-select
          v-model="placeAddress"
          placeholder="请选择"
          @change="onChangeAddress"
          style="margin-right: 10px"
        >
          <el-option
            v-for="item in addressList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input v-model="title" placeholder="请输入中文题名">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="onSearch"
          ></el-button
        ></el-input>
      </div>
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        style="width: 100%"
        :header-cell-style="{
          background: '#4f81bd',
          color: '#fff',
        }"
      >
        <el-table-column prop="surname" label="姓氏" width="100px">
        </el-table-column>
        <el-table-column prop="sourceID" label="sourceID" width="240px">
        </el-table-column>
        <el-table-column prop="title" label="题名" width="240px">
        </el-table-column>
        <el-table-column prop="area" label="地区" width="140px">
        </el-table-column>
        <el-table-column prop="version" label="版本"> </el-table-column>
        <el-table-column prop="pages" label="页数" width="140px">
        </el-table-column>
        <el-table-column prop="dTime" label="时间" width="140px">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >查看</el-button
            >
            <el-button @click="gotoEbook(scope.row)" type="text" size="small"
              >原图</el-button
            >
            <el-button
              type="text"
              size="small"
              v-show="scope.row.memberTreeFinished"
              @click="goToTree(scope.row.sourceID)"
              >世系树</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :hide-on-single-page="true"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
    
    <script>
import myHeader from "../../components/header/index.vue";
// import { getGenealogy } from "../../api/literature.js";
import { getGenealogy } from "@/api/drillingIn.js";
export default {
  components: {
    myHeader,
  },
  data() {
    return {
      isSenior: false,
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      title: "",
      addressList: [],
      loading: false,
      placeAddress: "all",
      SurName: "",
    };
  },
  created() {
    if (this.isMobileFn() && this.$route.path === "/ancestralGenealogy") {
      this.$router.push({
        path: "/ancestralGenealogyMobile",
        query: this.$route.query,
      });
    }
    this.pageIndex = 1;
    console.log(this.$store.state.user);
    this.addressList =
      this.$store.state.user.addressList[this.$route.query.question];
    this.SurName = this.$route.query.question.split(",")[0].slice(2);
    this.getTableList();
  },
  methods: {
    isMobileFn() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return Boolean(flag);
    },
    goToTree(sourceID) {
      let routeData = this.$router.resolve({
        path: "/tree/" + sourceID,
      });
      window.open(routeData.href, "_blank");
    },
    onChangeAddress(e) {
      this.placeAddress = e;
      this.pageIndex = 1;
      this.getTableList();
    },
    async getTableList() {
      this.loading = true;
      let tempAddress = "";
      if (this.placeAddress === "all" && this.addressList.length) {
        tempAddress = this.addressList.slice(1).reduce((prev, next) => {
          return prev ? prev + "," + next.value : next.value;
        }, "");
      }
      try {
        const res = await getGenealogy({
          PageIndex: this.pageIndex,
          PageSize: 8,
          AcientPlaceAddress:
            this.placeAddress === "all" ? tempAddress : this.placeAddress,
          Title: this.title,
          SurName: this.SurName,
        });
        this.tableData = res.items;
        this.total = res.totalCount;
        // if (this.total === 0) {
        //   const res2 = await GetPhoneNumber({
        //     area: this.placeAddress === "all" ? tempAddress : this.placeAddress,
        //   });
        //   this.phoneNumberList = res2.items;
        // }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getTableList();
    },
    handleCurrentChange(index) {
      this.pageIndex = index;
      this.getTableList();
    },
    onSearch() {
      this.pageIndex = 1;
      this.getTableList();
    },
    handleClick(data) {
      let routeData = this.$router.resolve({
        path: "/genealogyInfo",
        query: {
          sourceID: data.sourceID,
        },
      });
      window.open(routeData.href, "_blank");
    },
    gotoEbook(data) {
      let routeData = this.$router.resolve({
        path: "/ebook",
        query: {
          sourceID: data.sourceID,
          id: data.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
    
    <style scoped lang="scss">
.container {
  .box {
    width: 1300px;
    padding: 30px 0 0 0;
    margin: 0 auto;

    .search {
      display: flex;
      margin-bottom: 10px;
      align-items: center;
      span {
        display: inline-block;
        width: 100px;
      }
      .el-input {
        width: 300px;
      }
    }
  }
  .table {
    width: 1300px;
    padding: 30px 0 0 0;
    margin: 0 auto;

    .title {
      padding: 10px;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 1px solid #1a416c;
      background: #eee;
    }
    .name {
      display: flex;
      flex-wrap: wrap;
      background: #fff;

      .item {
        width: 250px;
        padding: 20px 5px;
        text-decoration: underline;
        color: #4c69bb;
        cursor: pointer;
        font-size: 16px;
      }

      .item:hover {
        color: red;
      }
    }
  }
  .el-pagination {
    text-align: center;
    padding-bottom: 10px;
  }
}
</style>